module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<div style=\"text-align:center\">\n  <h1>\n    Welcome to {{ title }}!\n  </h1>\n  \n<app-image-list></app-image-list>\n\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Sai Ashok Kumar/angular-gallery/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main